import { BiometricType } from '@tob/shared/biometrics';
import { OtpType } from '@shopee-user/otp-hook-base-constants';

export enum TrackingDataFieldTypeLoginMethod {
  Password = 'password',
  Phone = 'phone',
  Email = 'email',
  ReloginBiometric = 'biometric',
  ReloginPhone = 'phone_relogin',
  ReloginPassword = 'password_relogin',
  ThirdPartyShopee = 'third_party_shopee',
  ThirdPartyGoogle = 'third_party_google',
  ThirdPartyFacebook = 'third_party_facebook',
  ThirdPartyApple = 'third_party_apple',
}

export enum TrackingDataFieldTypeAccountType {
  OneCredential = 'one_credential',
  TobAccount = 'tob_account',
}

export type TrackingDataFieldLogin = {
  login_method: TrackingDataFieldTypeLoginMethod;
  account_type?: TrackingDataFieldTypeAccountType;
  biometric_type?: string;
  phone_verification_channel?: string;
};
export type TrackingDataLoginProps = {
  loginMethod: TrackingDataFieldTypeLoginMethod;
  accountType?: TrackingDataFieldTypeAccountType;
  biometricType?: BiometricType;
  otpType?: OtpType;
};

export type TrackingDataFieldLoginError = {
  login_method: TrackingDataFieldTypeLoginMethod;
  error_code: number;
  error_message?: string;
};

export type TrackingDataLoginErrorProps = {
  loginMethod: TrackingDataFieldTypeLoginMethod;
  error: number;
  errorMsg?: string;
};

export type TrackingDataFieldLoginByToken = {
  account_type: TrackingDataFieldTypeAccountType;
};
export type TrackingDataFieldLoginErrorAction = {
  login_method: TrackingDataFieldTypeLoginMethod;
  error_code: number;
  account_type?: TrackingDataFieldTypeAccountType;
};
export type TrackingDataLoginErrorActionProps = {
  loginMethod: TrackingDataFieldTypeLoginMethod;
  errorCode: number;
  accountType?: TrackingDataFieldTypeAccountType;
};
